export default "__VITE_ASSET__DhYydQx0__"